import React from 'react';
import { Search, Filter } from 'lucide-react';

export const BudgetSearchFilter = ({
  searchTerm,
  onSearchChange,
  filterType,
  onFilterChange
}) => {
  return (
    <div className="flex items-center w-full bg-white border border-slate-200 rounded-lg shadow-sm overflow-hidden focus-within:ring-2 focus-within:ring-brand-blue/20 focus-within:border-brand-blue transition-all">

      {/* Dropdown Filter */}
      <div className="relative flex items-center border-r border-slate-200 bg-slate-50">
        <div className="pl-3 pr-1 text-slate-500">
          <Filter size={14} />
        </div>
        <select
          value={filterType}
          onChange={(e) => onFilterChange(e.target.value)}
          className="appearance-none bg-transparent py-2.5 pl-1 pr-8 text-sm font-medium text-slate-700 outline-none cursor-pointer hover:text-brand-blue transition-colors"
        >
          <option value="All">All Files</option>
          <option value="Catalog">Catalog</option>
          <option value="Stock">Stock</option>
        </select>
        {/* Custom Chevron for select */}
        <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
      </div>

      {/* Search Input */}
      <div className="relative flex-1 flex items-center">
        <div className="pl-3 text-slate-400">
          <Search size={16} />
        </div>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search budgets, files, or vendors..."
          className="w-full py-2.5 pl-2 pr-4 text-sm text-slate-800 bg-transparent outline-none placeholder:text-slate-400"
        />
      </div>

    </div>
  );
};
